export const manualBillingConstants = {
    ...getConstantObj()
};

function getConstantObj() {
    let obj = {
        resetFirebirdService_request: "resetFirebirdService_request",
        resetFirebirdService_success: "resetFirebirdService_success",
        resetFirebirdService_failure: "resetFirebirdService_failure",
    }

    let obj_formatted = {};
    let domain = "billingPortal.manualBilling/";
    for (let property in obj) {
        if (obj.hasOwnProperty(property)) {
            obj_formatted[property] = domain + obj[property];
        }
    }

    return obj_formatted;
}